import React, { useEffect, useState } from "react";
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { Button } from "../../../buttons";
import { BannerCardType } from "../../../banner-block/banner-card/lib/banner-card-type";
import SmartLink from '../../../link';
import ChevronRightIcon from '../../../../lib/fontawesome/ChevronIcons/Right';
import ChevronBottomIcon from '../../../../lib/fontawesome/ChevronIcons/Bottom';
import UrlHelper from "../../../../lib/utils/url-helper";

import * as styles from './index.module.scss';

const mobileMenuWidth = 1099;

export const HeaderSectionBottom = ({ 
  menuItems,
  menuState,
  setMenuState
}) => (
  <div className={styles.bottom + " " + ((menuState === true) ? styles.active : '') }>
    <button
      className={styles.close}
      onClick={() => setMenuState(false)}
    >Close</button>
    <div
      className={styles.overlay}
      onClick={() => setMenuState(false)} />
    <ul className={styles.menu}>
      {menuItems.map((menuItem, index) => <MenuItem lastOption={menuItems.length - 1 === index} key={`header-navigation-${menuItem.id}`} {...menuItem} level={0} menuState={menuState} setMenuState={setMenuState} />)}
    </ul>
  </div>
)

const MenuItem = ({
  menuState,
  setMenuState,
  id,
  image,
  level,
  description,
  url,
  openInANewTab,
  title,
  subMenu,
  template,
  styleAsAButton,
  featuredBlock,
  parent,
  lastOption,
  displayAsSectionTitle,
  displayAsFeaturedLink
}) => {
  const [subNavState,setSubNavState] = useState(false);
  const [subNavDismissed, setSubNavDismissed] = useState(false);

  const closeMenuOnMobile = () => {
    if (typeof window !== 'undefined' && window.innerWidth <= mobileMenuWidth)
      setMenuState(false);
  };

  const closeSubNavOnDesktop = ({ target }) => {
    if (typeof window !== 'undefined' && window.innerWidth > mobileMenuWidth && target.closest('a'))
      setSubNavDismissed(true);
  };

  useEffect(() => {
    if (subNavState === true && menuState === false)
      setSubNavState(false);
  })

  //Get rid of spaces and hypthens
  let subMenuTemplateClassName = template && template.length ? template.split(" ").join("").split('-').join('') : '';

  const formattedUrl = UrlHelper.formatInternalUrl(url);

  return (
    <li onMouseLeave={() => setSubNavDismissed(false)} className={`${ !formattedUrl && styles.inactiveLink } ${styles.listItem} ${styles[`listItem_${subMenuTemplateClassName}`]} ${styles[`listItem${level}`]}` + ( styleAsAButton === 'Yes' ? ` ${styles.listItem_Button}` : '' ) + (subNavState ? ` ${styles.open}` : '') + (subNavDismissed ? ` ${styles.dismissed}` : '') + (parent === true ? ` ${styles.parentLink}` : '') + (displayAsFeaturedLink ? ` ${styles.featuredLinkItem}` : '') + (displayAsFeaturedLink && !description ? ` ${styles.featuredLinkItemNoDescription}` : '') + (subMenu && subMenu.filter(item => item.displayAsFeaturedLink).length > 1 ? ` ${styles.listItemMultipleFeaturedLinks}` : '') }>
      {styleAsAButton === 'Yes' ? (
        <Button
          href={formattedUrl} 
          content={title} 
          size='small'
          additionalClasses={styles.button} />
      ) : (
        <SmartLink
          href={formattedUrl || '#'}
          className={`${styles.bottomLink} ${styles[`bottomLink${level}`]} ${(subMenu && subMenu.length > 0) || displayAsSectionTitle ? styles.subMenuLink : ''} ${displayAsFeaturedLink ? styles.featuredLink : ''} ${displayAsFeaturedLink && !image?.gatsbyImageData ? styles.featuredLinkNoImage : ''}`}
          target={(openInANewTab === 'Yes') ? '_blank' : '_self'}
          aria-label={!title && !description ? (image?.gatsbyImageData ? 'Navigation link' : 'Menu link') : undefined}
          onClick={(e => {
            if (typeof window === 'undefined')
              return;

            if (window.innerWidth > mobileMenuWidth)
              return;

            if (subMenu && subMenu.length > 0 && level === 0) {
              e.preventDefault();
              setSubNavState(true);
            } else {
              closeMenuOnMobile();
            }

            return;
          })}>
            {image?.gatsbyImageData && (
              <GatsbyImage image={getImage(image)} objectFit="contain" alt={title || description || 'Navigation link'} />
            )}
            {(title || description) && (
              <span>
                {title}
                {description && <p>{description}</p>}
              </span>
            )}
            {subMenu && subMenu.length > 0 && level === 0 && <div className={styles.mobileIcon} aria-hidden="true"><ChevronRightIcon /></div>}
            {subMenu && subMenu.length > 0 && level === 0 && <div className={styles.desktopIcon} aria-hidden="true"><ChevronBottomIcon /></div>}
        </SmartLink>
      )}
      {subMenu && subMenu.length > 0 && (
        <div onClick={closeSubNavOnDesktop} className={`${styles.subNav} ${template === "Dropdown" && lastOption && styles.lastOption} ${styles[`subNav_${subMenuTemplateClassName}`]} ${styles[`subNav${level}`]} ${subMenu.filter(item => item.displayAsFeaturedLink).length > 0 ? styles.subNavMultipleFeaturedLinks : ''}`}>
          <button
            className={styles.back}
            onClick={() => setSubNavState(false)}
          >Back</button>
          {featuredBlock && featuredBlock.length > 0 && (
            <div className={`${styles.blocks} ${styles.blocksDesktop}`} onClick={closeMenuOnMobile}>
              {featuredBlock.map((block, index) => <BannerCardType key={`header-nav-${id}-${level}-desktop-${index}`} {...block} titleHtmlTag={`span`} />)}
            </div>
          )}
          <ul className={`${styles[`subNav${level}`]} subNav${level} ${subMenu.filter(item => item.displayAsSectionTitle).length > 1 ? styles.sectionTitleGap : ''}`}>
            {level === 0 && (
              <MenuItem
              key={`header-navigation-${id}-level-${level}-mobile`}
              id={id}
              level={level + 1}
              url={url}
              openInANewTab={openInANewTab}
              parent={true}
              title={title}
              menuState={menuState}
              setMenuState={setMenuState} />
            )}
            {featuredBlock && featuredBlock.length > 0 && (
              <li className={styles.blocksListItem}>
                <div className={`${styles.blocks} ${styles.blocksMobile}`} onClick={closeMenuOnMobile}>
                  {featuredBlock.map((block, index) => <BannerCardType key={`header-nav-${id}-${level}-mobile-${index}`} {...block} titleHtmlTag={`span`} />)}
                </div>
              </li>
            )}
            {subMenu.map(menuItem => <MenuItem key={`header-navigation-${menuItem.id}-level-${level}`} {...menuItem} level={level + 1} menuState={menuState} setMenuState={setMenuState} />)}
          </ul>
        </div>
      )}
    </li>
  )
}
